import React, { useContext } from 'react'
import { MetricsContext } from '../context'
import { Card, CardHeading, CardContent } from '../../../components/layout/Card'
import { R } from '@utils/currency'

export const TotalAssetsCards = ({ usePresentValue }) =>
  <div className='metrics-dashboard__total-assets-cards'>
    <AssetsUnderAdvice usePresentValue={usePresentValue} />
    <AssetsUnderManagement usePresentValue={usePresentValue} />
  </div>

const AssetsUnderAdvice = ({ usePresentValue }) => {
  const { state } = useContext(MetricsContext)
  let { assetsUnderAdvice } = state
  return (
    <Card>
      <CardHeading>
        <h5>Assets under advice</h5>
      </CardHeading>
      <CardContent>
        <h1 className='text-center'>{R(assetsUnderAdvice).format()}</h1>
      </CardContent>
    </Card>
  )
}

const AssetsUnderManagement = ({ usePresentValue }) => {
  const { state } = useContext(MetricsContext)
  const { assetsUnderManagement } = state
  return (
    <Card>
      <CardHeading>
        <h5>Assets under management</h5>
      </CardHeading>
      <CardContent>
        <h1 className='text-center'>{R(assetsUnderManagement).format()}</h1>
      </CardContent>
    </Card>
  )
}
